import type { useRender } from "@base-ui/react/use-render";

import { Addon, Affix, Content, WrapperClickable } from "../primitives";

export type ButtonProps = {
	render?: useRender.ComponentProps<"button">["render"];
	prefix?: Affix.AffixProps;
	content: Content.ContentProps;
	addon?: Addon.AddonProps;
	suffix?: Affix.AffixProps;
	disabled?: boolean;
	selected?: boolean;
};

export const Button = ({ render, prefix, content, addon, suffix, disabled, selected }: ButtonProps) => {
	return (
		<WrapperClickable render={render} disabled={disabled} selected={selected}>
			{prefix && <Affix.Affix {...prefix} disabled={disabled} selected={selected} />}
			<Content.Content {...content} disabled={disabled} selected={selected} />
			{addon && <Addon.Addon {...addon} disabled={disabled} selected={selected} />}
			{suffix && <Affix.Affix {...suffix} disabled={disabled} selected={selected} />}
		</WrapperClickable>
	);
};
